import React from 'react'
import { useTranslation } from 'react-i18next'
import { VoiceWaveIcon } from './icons'
import { cx } from './cx'
import styles from './index.module.scss'

interface CopilotLauncherProps {
  hidden: boolean
  onClick: () => void
}

const CopilotLauncher: React.FC<CopilotLauncherProps> = ({ hidden, onClick }) => {
  const { t } = useTranslation()
  return (
    <button className={cx(styles.fab, hidden && styles.fabHidden)} onClick={onClick} aria-label={t('genAI.copilot-open')}>
      <VoiceWaveIcon className={styles.fabIcon} />
    </button>
  )
}

export default CopilotLauncher
